import React, { ReactNode, VFC } from 'react';

interface Props {
  children: ReactNode;
}
const AppViewLayout: VFC<Props> = ({ children }: Props) => {
  return <>{children}</>;
};

export default AppViewLayout;
